import React from 'react';

const Marketing = () => {
    return (
        <div className="page">
            <div className="page-header">
                <h1>Marketing</h1>
            </div>
            <div className="card">
                <h2>Marketing Dashboard</h2>
                <p style={{ color: 'var(--text-muted)' }}>Coming soon...</p>
            </div>
        </div>
    );
};

export default Marketing;